export default __webpack_public_path__ + "static/media/newyear5.c6f418e6.png";